import { NavLink } from "react-router-dom";
import { publicUrlFor } from "../../../globals/constants";
import { useState } from "react";

function Header() {
  const [isActive, setIsActive] = useState(false);

  function toggleNavClass() {
    setIsActive(!isActive);
  }

  return (
    <header
      className={
        "site-header header-style-3 mobile-sider-drawer-menu " +
        (isActive ? "active" : "")
      }
    >
      {/*  background-color: #1e8fd0; --- OLD COLOR */}
      <div className="sticky-header main-bar-wraper  navbar-expand-lg">
        <div className="main-bar">
          <div className="container-fluid clearfix">
            <div className="logo-header">
              <div className="logo-header-inner logo-header-one">
                <NavLink to="/">
                  <img
                    src={publicUrlFor("/assets/images/logo1.png")}
                    alt="#"
                  />
                </NavLink>
              </div>
            </div>

            {/* NAV Toggle Button */}
            <button
              id="mobile-side-drawer"
              data-target=".header-nav"
              data-toggle="collapse"
              className="navbar-toggler collapsed"
              onClick={toggleNavClass}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar icon-bar-first"></span>
              <span className="icon-bar icon-bar-two"></span>
              <span className="icon-bar icon-bar-three"></span>
            </button>

            {/* MAIN Vav */}
            <div className="nav-animation header-nav navbar-collapse collapse d-flex justify-content-center">
              <ul className=" nav navbar-nav">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/about-us">About Us</NavLink>
                </li>
                <li>
                  <NavLink to="/services/services2">Services</NavLink>
                </li>
 
                <li>
                  <NavLink to="/contact-us">Contact</NavLink>
                </li>
                <li>
                  <NavLink to="/hiring">Join us</NavLink>
                </li>
               
              </ul>
            </div>

            {/* Header Right Section */}
            <div className="extra-nav header-2-nav">
          
              <div className="extra-cell">
                <div className="header-nav-call-section">
                  <div className="detail">
                    <span className="title">Contact us</span>
                    <span>
                      <a href="tel:7068290682">+91 70682-90682</a>
                    </span>
                  </div>
                  <div className="media">
                    <img
                      src={publicUrlFor("/assets/images/call1.png")}
                      alt="#"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SITE Search */}
        <div id="search">
          <span className="close"></span>
          <form
            role="search"
            id="searchform"
            action="/search"
            method="get"
            className="radius-xl"
          >
            <input
              className="form-control"
              name="q"
              type="search"
              placeholder="Type to search"
            />
            <span className="input-group-append">
              <button type="button" className="search-btn">
                <i className="fa fa-paper-plane"></i>
              </button>
            </span>
          </form>
        </div>
      </div>
    </header>
  );
}

export default Header;
